import React, { useCallback, useEffect, useState, useRef, memo } from 'react';
const testimonials = [{
  name: 'Valentina M.',
  location: 'Buenos Aires',
  role: 'Estudiante de Kinesiología — 4to año',
  avatar: 'https://images.unsplash.com/photo-1664575602554-2087b04935a5?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Tenía parcial de Biomecánica en 3 días y no entendía nada de los planos y ejes. Abrí el Tomo 2, busqué el capítulo, y en 40 minutos tenía todo claro con los protocolos resueltos. Saqué un 8. Primera vez que no recurso.',
  time: '22:14',
  reply: 'Eso es exactamente para lo que está pensado 🙌 Cuando el contenido está ordenado y con ejemplos, el parcial deja de ser un drama.'
}, {
  name: 'Tomás R.',
  location: 'Rosario',
  role: 'Estudiante de Kinesiología — 3er año',
  avatar: 'https://images.unsplash.com/photo-1618641986557-1ecd230959aa?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'El Bono de Signos Vitales y Valores de Alarma es un cheat code. Llegué a la rotación hospitalaria con todo claro: frecuencias, saturación, presión. El residente me preguntó si ya había rotado antes.',
  time: '11:30',
  reply: 'Me alegra un montón 😄 Ese bono está armado con lo que más te piden en sala. Bien que lo aprovechaste.'
}, {
  name: 'Lucía F.',
  location: 'Córdoba',
  role: 'Estudiante de Kinesiología — 2do año',
  avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Me trabé en el TP de evaluación postural. Abrí el Tomo 2 y encontré el protocolo completo con el formato que pedía la docente. Lo adapté en 20 minutos y lo entregué en tiempo. Me pusieron un 9.',
  time: '16:52',
  reply: 'Qué bueno 🥹 Los protocolos están pensados para que los puedas adaptar rápido sin partir de cero. Seguí así.'
}, {
  name: 'Camila B.',
  location: 'Tucumán',
  role: 'Estudiante de Kinesiología — 5to año',
  avatar: 'https://images.unsplash.com/photo-1619895862022-09114b41f16f?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Estaba en el peor momento de la carrera. Tres finales juntos, trabajo part-time y sin plata para clases particulares. El Tomo 4 de Clínica Kinésica me salvó el cuatrimestre. Todo lo que necesitaba en un solo lugar.',
  time: '09:03',
  reply: 'Esa situación es muy real y muy difícil 😔 Me alegra que hayas encontrado lo que necesitabas. Ya falta poco para terminar.'
}, {
  name: 'Sofía G.',
  location: 'Mendoza',
  role: 'Estudiante de Kinesiología — 4to año',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Las tablas de parámetros del Tomo 3 son lo que debería darte la facultad el primer día. Intensidades, frecuencias, tiempos de electroterapia en una sola hoja. Dejé de buscar en 5 libros distintos.',
  time: '19:27',
  reply: 'Exacto, para eso está 😊 Que todo esté en un lugar te ahorra tiempo y energía para lo que importa: entender y aprobar.'
}, {
  name: 'Mateo H.',
  location: 'Santa Fe',
  role: 'Estudiante de Kinesiología — 3er año',
  avatar: 'https://images.unsplash.com/photo-1625504615927-c14f4f309b83?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Le tenía miedo al final de Neurología. Es la materia que más recursa en mi facultad. Usé el Tomo 4 completo, los casos clínicos y el glosario. Aprobé de primera con un 8. No lo puedo creer todavía.',
  time: '14:11',
  reply: 'Creelo, te lo ganaste 💪 Neurología asusta porque es mucho contenido disperso. El Tomo 4 está hecho para ordenar exactamente eso.'
}, {
  name: 'Agustina P.',
  location: 'Salta',
  role: 'Estudiante de Kinesiología — 2do año',
  avatar: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=80&h=80&fit=crop&crop=face&q=60',
  quote: 'Soy más de estudiar con ejemplos que con teoría pura. El Tomo 1 tiene casos aplicados desde el primer capítulo. Anatomía y fisiología explicadas con contexto kinésico real. Primera vez que entiendo para qué sirve lo que estudio.',
  time: '21:05',
  reply: 'Eso marca toda la diferencia 😌 Cuando sabés por qué estudiás algo, lo recordás mucho mejor. Esa es la idea detrás de cada tomo.'
}];
function ChevronLeft() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-283">
      <path d="M15 18l-6-6 6-6" data-id="element-284" />
    </svg>;
}
function ChevronRight() {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-285">
      <path d="M9 18l6-6-6-6" data-id="element-286" />
    </svg>;
}
const WhatsAppChat = memo(function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-287">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-288">
        <div className="relative" data-id="element-289">
          <img src={t.avatar} alt={t.name} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-290" />
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-291" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-292">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-293">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-294">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-295">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-296">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-297" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 min-h-[160px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a'
    }} data-id="element-298">
        {/* Incoming bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-299">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-300" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-301">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-302">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-303">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-304">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-305">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-306" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-307" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-308">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1d4ed8',
          borderRight: '8px solid transparent'
        }} data-id="element-309" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#1d4ed8'
        }} data-id="element-310">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-311">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-312">
              <span className="text-xs" style={{
              color: '#bfdbfe'
            }} data-id="element-313">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-314">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bfdbfe" data-id="element-315" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bfdbfe" data-id="element-316" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-317">
        <div style={{
        color: '#8696a0'
      }} data-id="element-318">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-319">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-320" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-321">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-322">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-323">
            <path d="M12 15c1.66 0 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-324" />
          </svg>
        </div>
      </div>
    </div>;
});
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setSlideDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 250);
  }, [isAnimating]);
  const next = useCallback(() => {
    goTo((current + 1) % total, 'left');
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'right');
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 30%, rgb(255,255,255) 100%)'
  }} data-id="element-325">
      <div className="mx-auto max-w-2xl" data-id="element-326">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-327">
          Lo que dicen los estudiantes{' '}
          <span className="text-blue-700" data-id="element-328">que ya lo usan:</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-329">
          +1.800 estudiantes de todo el país ya tienen la carrera organizada.
        </p>

        {/* Carousel */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-330">
          {/* Arrow prev */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-0 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#1d4ed8',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-331">
            <ChevronLeft data-id="element-332" />
          </button>

          {/* Arrow next */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-0 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          backgroundColor: '#1d4ed8',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-333">
            <ChevronRight data-id="element-334" />
          </button>

          {/* Card */}
          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-335">
            <div style={{
            transition: isAnimating ? 'none' : 'opacity 0.25s ease, transform 0.25s ease',
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating ? `translateX(${slideDirection === 'left' ? '-30px' : '30px'})` : 'translateX(0)'
          }} data-id="element-336">
              <WhatsAppChat t={testimonials[current]} data-id="element-337" />
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgb(226,232,240)'
        }} data-id="element-338">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#1d4ed8',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-339" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-340">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'left' : 'right')} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#1d4ed8' : 'rgb(203,213,225)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-341" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs text-gray-400" data-id="element-342">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}